import logNewRelicCustom from '../../../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../../../constants';
import { findCabinetByIdExcludeVoidSpacer } from '../../../../../utils/cabinet-utils';
import { selectSpacerMediaUrl } from '../../../../../store/cabinetVisualizer/selectors';
import { isSpacerSku } from '../../../cabinetConstants';

/**
 * Get the spacer media URL for a cabinet if it's a spacer type
 * @param {Object} cabinet - The cabinet object with Sku and ChoiceId
 * @param {Object} cabinetVisualizer - The cabinet visualizer store state
 * @returns {string|null} The media URL or null if not a spacer
 */
export const getSpacerMediaUrl = (cabinet, cabinetVisualizer) => {
  if (!cabinet || !isSpacerSku(cabinet.Sku)) {
    return null;
  }
  return selectSpacerMediaUrl(cabinetVisualizer, cabinet.ChoiceId);
};

export const getImageWapperClass = ({ selectedCabinet, id }) => {
  if (selectedCabinet?.id === id) {
    return 'image-wrapper--active';
  }
  return 'image-wrapper';
};

export const getCabinetStyle = ({
  left, top, width, height, imageState, mirror, border
}) => {
  const styles = {
    left,
    width,
    height,
    top,
    transform: imageState === 'loaded' ? `scaleX(${mirror ? -1 : 1})` : null,
    border: border ? '2px solid rgb(249 99 2)' : null,
  };
  return styles;
};

export const getSpacerTextStyle = ({ origin, spacerName, mirror }) => {
  if (!origin || !spacerName) return {};
  const styles = {};
  if (origin.Width <= spacerName.length + 4) {
    styles.transform = 'rotate(-90deg)';
    styles.whiteSpace = 'nowrap';
  } else if (mirror) {
    styles.transform = 'scaleX(1)';
  }
  return styles;
};

export const handleImageError = ({
  isSmallWidth, itemId, designId, styleChoiceId, vizImageRoute, setImageState
}) => {
  setImageState(isSmallWidth ? 'smallWidth' : 'failed');
  if (![-1, -2].includes(itemId)) {
    logNewRelicCustom(NEW_RELIC_EVENTS.CABINET_IMAGE_FAILED_LOAD, {
      itemId,
      designId,
      styleChoiceId,
      vizImageRoute
    });
  }
};

export const handleImageLoad = ({ setImageState }) => {
  setImageState('loaded');
};

/**
 * Handle spacer image load error - log to New Relic and trigger fallback to text
 */
export const handleSpacerImageError = ({
  spacerMediaUrl, spacerName, designId, setSpacerImageFailed
}) => {
  setSpacerImageFailed(true);
  logNewRelicCustom(NEW_RELIC_EVENTS.CABINET_IMAGE_FAILED_LOAD, {
    spacerMediaUrl,
    spacerName,
    designId,
    type: 'spacer'
  });
};

const selectCabinet = ({ cabinets, id, setSelectedCabinet }) => {
  const selected = findCabinetByIdExcludeVoidSpacer(cabinets, id);
  if (selected) {
    setSelectedCabinet(selected);
  }
};

const handleImageClick = ({ event, cabinets, id, setSelectedCabinet }) => {
  event.preventDefault();
  event.stopPropagation();

  selectCabinet({ cabinets, id, setSelectedCabinet });
};

export const handleMouseDown = ({
  event, cabinets, id, setSelectedCabinet, setMouseDownPos
}) => {
  selectCabinet({ cabinets, id, setSelectedCabinet });
  setMouseDownPos({ mouseX: event.clientX, mouseY: event.clientY });
};

export const handleMouseUp = ({
  event, mouseDownPos, setMouseDownPos, cabinets, id, setSelectedCabinet
}) => {
  if (!mouseDownPos) return;
  const dx = Math.abs(event.clientX - mouseDownPos.mouseX);
  const dy = Math.abs(event.clientY - mouseDownPos.mouseY);
  const threshold = 5; // px
  if (dx < threshold && dy < threshold) {
    handleImageClick({ event, cabinets, id, setSelectedCabinet });
  }
  setMouseDownPos(null);
};
